import React, {PropTypes} from 'react';
import FormInput from './forminput.react';
// import Slider from './range/slider.react';
import Slider from 'rc-slider';
import {Col, Row} from 'react-bootstrap/lib/';
import './range/index.styl';

export default class RangeInput extends FormInput {
  static propTypes = {
    action: PropTypes.func.isRequired,
    name: PropTypes.string.isRequired,
    defaultValue: PropTypes.array,
    label: PropTypes.string.isRequired,
    range: PropTypes.bool.isRequired,
    min: PropTypes.number.isRequired,
    max: PropTypes.number.isRequired,
    marks: PropTypes.object,
    step: PropTypes.number,
    headingXs: PropTypes.number,
    inputsXs: PropTypes.number,
    minLabel: React.PropTypes.string,
    maxLabel: React.PropTypes.string
  }

  constructor(props) {
    super(props);
    this.state = {value: [0, 0]};
  }

  onChange(value) {
    this.setState({value: value});
  }

  onAfterChange(value) {
    const {name, action} = this.props;
    action({target: {name, value: {gte: value[0], lte: value[1]}}});
  }

  componentWillMount() {
    const {defaultValue} = this.props;
    if (defaultValue) this.setState({value: defaultValue});
  }

  render() {
    const {
      label,
      range,
      defaultValue,
      min,
      max,
      marks = {},
      step,
      headingXs = 12,
      inputsXs = 12,
      minLabel = 'Min',
      maxLabel = 'Max'
    } = this.props;

    return (
      <Row className="form-group range-slider-wrap">
        {label &&
          <Col xs={headingXs}>
            <label>{label}</label>
          </Col>
        }
        <Col xs={inputsXs} className="range-slider-wrap">
          {minLabel &&
            <span className="range-min">
              {minLabel}
            </span>
          }
          <Slider minLabel={minLabel} maxLabel={maxLabel} marks={marks} range={range} step={step} defaultValue={defaultValue} min={min} max={max} onAfterChange={::this.onAfterChange} onChange={::this.onChange} />
          {maxLabel &&
            <span className="range-max">
              {maxLabel}
            </span>
          }
        </Col>
      </Row>
    );
  }
}
